<template>
  <div class="relative">
    <div class="absolute bottom-0 left-4 top-4 -ml-px mt-0.5 w-0.5 bg-gray-100 md:left-5 md:top-5" />

    <div class="relative flex flex-col gap-y-6 md:gap-y-8">
      <slot />
    </div>
  </div>
</template>
